import "bootstrap/dist/css/bootstrap.min.css";

import { Route, useParams, Routes } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useState } from "react";

import SplashPage from "./splash_page/SplashPage.js";
import MainPage from "./main_page/MainPage.js";
import NavBar from "./main_page/components/NavBar/NavBar.js";
import AlertBanner from "./main_page/components/AlertBanner/AlertBanner.js";
import Footer from "./main_page/components/Footer.js";

import search_config from "./assets/data/search_config.json";
import trainings from "./assets/data/training_master.json";


function App() {
  /**
   * Main app component. Contains all of the state variables, event handlers, and splash page routes.
   * @param : None
   * @returns: training pages application JSX with dynamic routes to main page and each of the splash pages
   */

  // State variables
  const [trainingList, setTrainingList] = useState(trainings["training"]);
  const [focusAreaTraining, setFocusAreaTraining] = useState(trainings["training"]);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [focusArea, setFocusArea] = useState("");
  const [query, setQuery] = useState("");

  // Show all trainings and clear searching parameters
  const resetTrainings = () => {
    /**
     * Function that resets all search filters and the training results on the main page.
     * @param : None
     * @returns: None
     */

    setFocusArea("");
    setFocusAreaTraining(trainings["training"]);
    setQuery("");
    setTrainingList(trainings["training"]);
  };
  
  // Event handlers
  const carouselHandler = (selectedIndex) => {
    /**
     * Updates the carousel index when the module carousel rotates.
     * @param selectedIndex: numerical index to set the carousel index state to.
     * @returns: None
     */

    setCarouselIndex(selectedIndex);
  };
  
  const focusAreaHandler = (selectedFocusArea) => {
    /**
     * Focus area event handler, triggered when a focus area selection is made. Filters the full training array and updates the training list states.
     * @param selectedFocusArea: focus area selection made by the user
     * @returns: None
     */

    // If no focus area specified, then reset the trainings and query.
    if (!selectedFocusArea) {
      resetTrainings();
      return;
    }
    
    const filteredList = trainings["training"].filter(training => training[Object.keys(training)]["focus_area"] === selectedFocusArea);
    
    setFocusArea(selectedFocusArea);
    setFocusAreaTraining(filteredList); // This state variable is used for dynamic text query filtering (allows for inclusivity of the two search filters)
    setQuery("");
    setTrainingList(filteredList);
  }
  
  const queryHandler = (query) => {
    /**
     * Text search event handler, triggered when the text query is changed in the search bar. Extracts any keywords or phrases, filters the module results, and 
     * updates the query & training list states accordingly.
     * @param query: string object containing the text pattern inputted by the user
     * @returns: None
     */

    // If the query is empty or has leading whitespace w/ no other chars, no text search filtering is performed.
    if (!query.match(/\S/)) {
      focusAreaHandler(focusArea);
      return;
    }
    
    // Split the query based on whether it's a phrase (Regex pattern w/ removal of excess whitespace) or keywords (space b/w words)
    let querySplit;
    const re = /"(.*?)"/g;

    // If a phrase is found in the query, extract it (and any other keywords) and get rid of any un-needed space. Otherwise, extract each of the keywords.
    if (query.match(re)) {
      querySplit = query.split(re).filter(queryElem => 
        (queryElem !== '') && (queryElem !== ' ')
        ).map(queryElem => queryElem.trim());
    } else {
      querySplit = query.split(" ").filter(queryElem => (queryElem !== ''));
    }
    
    // Filter the focus area-specific training list with the configured search fields (case-insensitive)
    const filteredList = focusAreaTraining.filter(doc => {
      const training = doc[Object.keys(doc)];

      return querySplit.some(queryElem => 
        search_config["search_fields"].some(field => {
          if (field === "tags") {
            if (!training[field]) return false;
            const searchArray = Array.isArray(training[field]) ? training[field] : [training[field]];
            const lowerCaseTags = searchArray.map(tag => tag.toLowerCase());
          
            return lowerCaseTags.some(tag => tag.includes(queryElem.toLowerCase()));
          }

          return training[field].toLowerCase().includes(queryElem.toLowerCase());
        })
      );
    })

    setQuery(query);
    setTrainingList(filteredList);
  };

  function SplashPageRoute() {
    /**
     * When a module card is clicked, this function is called and generates a splash page component from the splashTraining URL 
     * parameter (which is the training key of the selected module card).
     * @param : None
     * @returns: splash page component of the selected module to be rendered
     */

    const { splashTraining } = useParams();
    const module = trainingList.find(training => Object.keys(training)[0] === splashTraining);

    return <SplashPage module={module[Object.keys(module)]} />;
  }

  return (
      <div className="App">
        <NavBar/>
	  {/*<AlertBanner message="Placeholder banner " />*/}
        <Container>
          <Routes>
            <Route path="/" element={
              <MainPage trainingList={trainingList} 
                        carouselList={trainings["carousel"]} 
                        carouselHandler={carouselHandler} 
                        carouselIndex={carouselIndex} 
                        focusAreaHandler={focusAreaHandler} 
                        focusArea={focusArea} queryHandler={queryHandler} 
                        query={query} resetTrainings={resetTrainings}
              />
            }/>
            
            <Route path="/:splashTraining" element={<SplashPageRoute/>} />
          </Routes>
        </Container>
        <Footer/>
      </div>
  );
}

export default App;
